import { FC, memo, useEffect } from "react"
import { ShopBar } from "./shop-bar"
import ShopBarAbandonCartModal from "./shop-bar/ShopBarAbandonCartModal"

export const SiteHeaderEcomm: FC = memo(() => {
	useEffect(() => {
		const element = document.getElementById("app-main")
		if (element) {
			element.style.backgroundColor = "white"
		}
	})

	return (
		<header>
			<ShopBar />
			<ShopBarAbandonCartModal />
		</header>
	)
})
